// Security+ App Constants
// Extracted from App.js for better maintainability and token efficiency
// This file contains application-wide constants and configuration values

// Local Storage Keys
export const STORAGE_KEYS = {
  BOOKMARKS: 'secplus-bookmarks',
  STUDY_PROGRESS: 'secplus-progress',
  STUDY_TIME: 'secplus-study-time',
  VIEWED_CONCEPTS: 'secplus-viewed',
  USER_PREFERENCES: 'secplus-preferences'
};

// Search Configuration
export const SEARCH_CONFIG = {
  MIN_SEARCH_LENGTH: 2,
  RELEVANCE_SCORES: {
    TITLE_MATCH: 10,
    TITLE_START: 15,
    EXPLANATION_MATCH: 5,
    EXAMPLES_MATCH: 3,
    MNEMONIC_MATCH: 2,
    WORD_MATCH_TITLE: 8,
    WORD_MATCH_EXPLANATION: 4
  },
  MIN_WORD_LENGTH: 2
};

// App Metadata
export const APP_INFO = {
  NAME: 'CompTIA Security+ Study App',
  VERSION: '2.0.0',
  EXAM_CODE: 'SY0-701',
  DESCRIPTION: 'Interactive study tool for CompTIA Security+ certification'
};

// UI Configuration
export const UI_CONFIG = {
  MODAL_ANIMATION_DURATION: 200,
  STUDY_TIMER_UPDATE_INTERVAL: 1000,
  DEFAULT_SEARCH_PLACEHOLDER: 'Search concepts, explanations, or examples...'
};

// Domain Colors (for consistency)
export const DOMAIN_COLORS = {
  DOMAIN_1: {
    bg: 'bg-purple-600',
    text: 'text-purple-600',
    hover: 'hover:bg-purple-700'
  },
  DOMAIN_2: {
    bg: 'bg-orange-500', 
    text: 'text-orange-500',
    hover: 'hover:bg-orange-600'
  },
  DOMAIN_3: {
    bg: 'bg-blue-500',
    text: 'text-blue-500', 
    hover: 'hover:bg-blue-600'
  },
  DOMAIN_4: {
    bg: 'bg-yellow-500',
    text: 'text-yellow-500',
    hover: 'hover:bg-yellow-600'
  },
  DOMAIN_5: {
    bg: 'bg-green-500',
    text: 'text-green-500',
    hover: 'hover:bg-green-600'
  }
};